import { memberConstants } from "./types";
import { beginLogout } from "../login/actions";
import { alertActions, loading } from "../alert/actions";
import {
  getMember,
  getAccount,
  getMembers,
  getMemberNumbers,
  getAgent,
  getDrawDetails,
  getFreezeDetails,
  getDocument,
  getDocumentLink,
  addNewMember,
  sendSmsNewMember,
  saveNewMember,
  controlContactInfo,
  saveContactInfo,
  reSendValidateCodeContactInfo,
  getExpensesByNo,
  downloadCdnFileService,
  downloadReportFileService,
} from "../../../services/member.service";

const endError = (error) => {
  return (dispatch) => {
    dispatch(loading.hideLoading());
    if (error?.response?.status === 401 || error?.message === "Network Error") {
      dispatch(beginLogout());
    } else {
      dispatch(alertActions.error(error));
      dispatch({
        type: memberConstants.MEMBER_ERROR,
        error,
      });
    }
  };
};

const getMemberInfo = () => {
  return async (dispatch) => {
    try {
      const res = await getMember();
      dispatch(endMemberInfo(res.data));
    } catch (error) {
      dispatch(endError(error));
    }
  };
};

const endMemberInfo = (data) => ({
  type: memberConstants.MEMBER_INFO,
  payload: { info: data },
});

const getAccountInfo = () => {
  return async (dispatch) => {
    try {
      const res = await getAccount();
      dispatch(endAccountInfo(res.data));
    } catch (error) {
      dispatch(endError(error));
    }
  };
};

const endAccountInfo = (data) => ({
  type: memberConstants.MEMBER_INFO,
  payload: { account: data },
});

const getMembersInfo = (memberId) => {
  return (dispatch) => {
    dispatch(request());
    dispatch(loading.showLoading());
    getMembers(memberId).then(
      (response) => {
        dispatch(success(response.data));
        dispatch(loading.hideLoading());
      },
      (error) => {
        dispatch(loading.hideLoading());
        dispatch(endError(error));
      }
    );
  };
  function request() {
    return {
      type: memberConstants.MEMBERS_INFO_REQUEST,
      payload: {},
    };
  }
  function success(data) {
    return {
      type: memberConstants.MEMBERS_INFO_SUCCESS,
      payload: { members: data },
    };
  }
};

const getMemberNumber = () => {
  return async (dispatch) => {
    try {
      const res = await getMemberNumbers();
      dispatch(endMemberNumber(res.data));
    } catch (error) {
      dispatch(endError(error));
    }
  };
};

const endMemberNumber = (data) => ({
  type: memberConstants.MEMBER_NUMBER,
  payload: { numbers: data },
});

const getDrawDetail = (memberId, drawId) => {
  return async (dispatch) => {
    try {
      const res = await getDrawDetails(memberId, drawId);
      dispatch(endDrawDetail(res.data));
    } catch (error) {
      dispatch(endError(error));
    }
  };
};

const endDrawDetail = (data) => ({
  type: memberConstants.DRAW_DETAIL,
  payload: { drawDetail: data, drawIsOpen: true },
});

const getFreezeDetail = (memberId, sourceId) => {
  return async (dispatch) => {
    try {
      const res = await getFreezeDetails(memberId, sourceId);
      dispatch(endFreezeDetail(res.data));
    } catch (error) {
      dispatch(endError(error));
    }
  };
};

const endFreezeDetail = (data) => ({
  type: memberConstants.FREEZE_DETAIL,
  payload: { freezeDetail: data, freezeIsOpen: true },
});

const hideDrawModal = () => {
  return { type: memberConstants.HIDE_DRAW_MODAL };
};

const hideFreezeModal = () => {
  return { type: memberConstants.HIDE_FREEZE_MODAL };
};

const getExpensesByMemberNo = (memberNo, paymentType) => {
  return async dispatch => {
    const res = await getExpensesByNo(memberNo, paymentType).then(
      response => {
        dispatch(success(response.data));
      },
      error => {
        dispatch(endError(error));
      }
    );
  };
  function success(data) {
    return {
      type: memberConstants.EXPENSE_BY_MEMBER_NO_SUCCESS,
      payload: { expenses: data }
    };
  }
};

const getDocumentFile = (documentId,ext, documentName) => {
  return async (dispatch) => {
    try {
      const res = await getDocument(documentId,ext, documentName);
      dispatch(endDocumentFile(res));
    } catch (error) {
      dispatch(endError(error));
    }
  };
};

const endDocumentFile = (data) => ({
  type: memberConstants.DOCUMENT_FILE,
  payload: { file: data },
});

const getDocumentLinks = (documentId) => {
  return async (dispatch) => {
    try {
      const res = await getDocumentLink(documentId);
      dispatch(endDocumentLink(res));
    } catch (error) {
      dispatch(endError(error));
    }
  };
};

const endDocumentLink = (data) => ({
  type: memberConstants.DOCUMENT_FILE,
  payload: { link: data },
});

const getAgentInfo = () => {
  return async (dispatch) => {
    try {
      const res = await getAgent();
      dispatch(endAgentInfo(res.data));
    } catch (error) {
      dispatch(endError(error));
    }
  };
};

const endAgentInfo = (data) => ({
  type: memberConstants.AGENT_INFO,
  payload: { agent: data },
});

const addNewMembers = (newMember) => {
  return (dispatch) => {
    dispatch(request("addNewMembers"));
    dispatch(loading.showLoading());
    addNewMember(newMember).then(
      (response) => {
        if (response?.data?.code === 2) {
          dispatch(loading.hideLoading());
          dispatch(success(response, newMember, Date.now()));
        } else {
          dispatch(loading.hideLoading());
          dispatch(
            alertActions.showError(
              response?.data?.return !== null
                ? response?.data?.return
                : "Beklenmeyen bir hata oluştu."
            )
          );
        }
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(response) {
    return {
      type: memberConstants.CONTROL_MEMBER_REQUEST,
      payload: { response },
    };
  }
  function success(response, newMember, countDate) {
    return {
      type: memberConstants.CONTROL_MEMBER_SUCCESS,
      payload: {
        response,
        newMember,
        countDate,
      },
    };
  }
  function failure(error) {
    return { type: memberConstants.MEMBER_ERROR, error };
  }
};

const saveNewMembers = (newMember) => {
  return (dispatch) => {
    dispatch(request("saveNewMembers"));
    dispatch(loading.showLoading());
    saveNewMember(newMember).then(
      (response) => {
        if (response?.data?.code === 2) {
          dispatch(loading.hideLoading());
          dispatch(success(response, newMember, Date.now() - 180000));
        } else {
          dispatch(loading.hideLoading());
          dispatch(
            alertActions.showError(
              response?.data?.return !== null
                ? response?.data?.return
                : "Beklenmeyen bir hata oluştu."
            )
          );
        }
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(response) {
    return {
      type: memberConstants.SAVE_MEMBER_REQUEST,
      payload: { response },
    };
  }
  function success(response, newMember, countDate) {
    return {
      type: memberConstants.SAVE_MEMBER_SUCCESS,
      payload: { response, newMember, countDate },
    };
  }
  function failure(error) {
    return { type: memberConstants.MEMBER_ERROR, error };
  }
};

const clearNewMemberRedirect = () => {
  return { type: memberConstants.CLEAR_NEW_MEMBER_REDIRECT };
};

const clearNewMemberDone = () => {
  return { type: memberConstants.CLEAR_NEW_MEMBER_DONE };
};

const sendSmsNewMembers = (newMember) => {
  return (dispatch) => {
    dispatch(request("sendSmsNewMembers"), Date.now());
    dispatch(loading.showLoading());
    sendSmsNewMember(newMember).then(
      (response) => {
        dispatch(loading.hideLoading());
        if (response?.data?.code === 2) {
          dispatch(success(response, newMember, Date.now()));
        } else {
          dispatch(
            alertActions.showError(
              response?.data?.return !== null
                ? response?.data?.return
                : "Beklenmeyen bir hata oluştu."
            )
          );
        }
      },
      (error) => {
        dispatch(loading.hideLoading());
        dispatch(alertActions.error(error));
        dispatch(failure(error));
      }
    );
  };
  function request(response, countDate) {
    return {
      type: memberConstants.RESEND_SMS_NEW_MEMBER_REQUEST,
      payload: { response, countDate },
    };
  }
  function success(response, newMember, countDate) {
    return {
      type: memberConstants.RESEND_SMS_NEW_MEMBER_SUCCESS,
      payload: {
        response,
        newMember,
        countDate,
      },
    };
  }
  function failure(error) {
    return { type: memberConstants.MEMBER_ERROR, error };
  }
};

const controlContactInfos = (bilgi, iletisimTur,countryPhoneCode) => {
  return (dispatch) => {
    dispatch(request("controlContactInfos"));
    dispatch(loading.showLoading());
    controlContactInfo(bilgi, iletisimTur,countryPhoneCode).then(
      (response) => {
        dispatch(loading.hideLoading());
        if (response?.data?.code === 2) {
          dispatch(success(response, bilgi, iletisimTur, Date.now()));
        } else {
          dispatch(loading.hideLoading());
          dispatch(
            alertActions.showError(
              response?.data?.return !== null
                ? response?.data?.return
                : "Beklenmeyen bir hata oluştu."
            )
          );
        }
      },
      (error) => {
        dispatch(loading.hideLoading());
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(response) {
    return {
      type: memberConstants.CONTROL_CARD_CONTACT_INFO_REQUEST,
      payload: { response },
    };
  }
  function success(response, bilgi, iletisimTur, countDate) {
    return {
      type: memberConstants.CONTROL_CARD_CONTACT_INFO_SUCCESS,
      payload: {
        response,
        bilgi,
        iletisimTur,
        countDate,
      },
    };
  }
  function failure(error) {
    return { type: memberConstants.MEMBER_ERROR, error };
  }
};

const saveContactInfos = (bilgi, iletisimTur, smsKod) => {
  return (dispatch) => {
    dispatch(request("saveContactInfos"));
    dispatch(loading.showLoading());
    saveContactInfo(bilgi, iletisimTur, smsKod).then(
      (response) => {
        dispatch(loading.hideLoading());
        if (response?.data?.code === 2) {
          dispatch(success(response));
          dispatch(
            alertActions.success(
              "Bilgileriniz başarıyla kaydedilmiştir.",
              "/Home/AccountInfo"
            )
          );
        } else {
          dispatch(loading.hideLoading());
          dispatch(
            alertActions.showError(
              response?.data?.return !== null
                ? response?.data?.return
                : "Beklenmeyen bir hata oluştu."
            )
          );
        }
      },
      (error) => {
        dispatch(loading.hideLoading());
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(response) {
    return {
      type: memberConstants.SAVE_CARD_CONTACT_INFO_REQUEST,
      payload: { response },
    };
  }
  function success(response) {
    return {
      type: memberConstants.SAVE_CARD_CONTACT_INFO_SUCCESS,
      payload: {
        response,
      },
    };
  }
  function failure(error) {
    return { type: memberConstants.MEMBER_ERROR, error };
  }
};

const reSendValidateCodeContactInfos = (bilgi, iletisimTur) => {
  return (dispatch) => {
    dispatch(request("reSendValidateCodeContactInfos"));
    dispatch(loading.showLoading());
    reSendValidateCodeContactInfo(bilgi, iletisimTur).then(
      (response) => {
        dispatch(loading.hideLoading());
        if (response?.data?.code === 2) {
          dispatch(success(response, bilgi, iletisimTur, Date.now()));
        } else {
          dispatch(loading.hideLoading());
          dispatch(
            alertActions.showError(
              response?.data?.return !== null
                ? response?.data?.return
                : "Beklenmeyen bir hata oluştu."
            )
          );
        }
      },
      (error) => {
        dispatch(loading.hideLoading());
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(response) {
    return {
      type: memberConstants.RESEND_VALIDATECODE_CONTACT_INFO_REQUEST,
      payload: { response },
    };
  }
  function success(response, bilgi, iletisimTur, countDate) {
    return {
      type: memberConstants.RESEND_VALIDATECODE_CONTACT_INFO_SUCCESS,
      payload: {
        response,
        bilgi,
        iletisimTur,
        countDate,
      },
    };
  }
  function failure(error) {
    return { type: memberConstants.MEMBER_ERROR, error };
  }
};

const sendMemberAddress = (newMember) => (dispatch) => {
  dispatch({
    type: memberConstants.SEND_NEW_MEMBER_ADDRESS,
    payload: {
      newMember,
    },
  });
};

const clearContactInfoRedirect = () => {
  return { type: memberConstants.CLEAR_CONTACT_INFO_REDIRECT };
};



const downloadCdnFile = (id, memberId, ext, documentName) => {
  return async (dispatch) => {
    try {
      const res = await downloadCdnFileService(id, memberId,ext, documentName);
      dispatch(endDocumentFile(res));
    } catch (error) {
      dispatch(endError(error));
    }
  };
};


const downloadReportFile = (uyelikId, raporId, ext, documentName) => {
  return async (dispatch) => {
    try {
      const res = await downloadReportFileService(uyelikId, raporId, ext, documentName);
      dispatch(endDocumentFile(res));
    } catch (error) {
      dispatch(endError(error));
    }
  };
};

export {
  getMemberInfo,
  getAccountInfo,
  getMembersInfo,
  getMemberNumber,
  getAgentInfo,
  getDrawDetail,
  getFreezeDetail,
  getDocumentFile,
  getDocumentLinks,
  addNewMembers,
  saveNewMembers,
  hideDrawModal,
  hideFreezeModal,
  sendSmsNewMembers,
  sendMemberAddress,
  clearNewMemberRedirect,
  controlContactInfos,
  saveContactInfos,
  reSendValidateCodeContactInfos,
  clearContactInfoRedirect,
  clearNewMemberDone,
  getExpensesByMemberNo,
  downloadCdnFile,
  downloadReportFile,
};
